import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material";

interface DomainSelectProps {
  domains: { id: string; name: string }[];
  loading: boolean;
  error?: string;
  selectedDomain: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const DomainSelect: React.FC<DomainSelectProps> = ({
  domains,
  loading,
  error,
  selectedDomain,
  onChange,
}) => {
  return (
    <FormControl sx={{ minWidth: "100%", mb: 1 }}>
      <InputLabel id="demo-simple-select-helper-label">Domínio</InputLabel>
      <Select
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        value={selectedDomain}
        label="Domínio"
        data-testid="domain-select"
        onChange={onChange}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={24} />
          </MenuItem>
        ) : (
          domains.map((domain) => (
            <MenuItem key={domain.id} value={domain.id}>
              {domain.name}
            </MenuItem>
          ))
        )}
      </Select>
      {error && <p style={{ color: "red" }}>{error}</p>}{" "}
      {/* Exibindo erro caso falhe */}
    </FormControl>
  );
};

export default DomainSelect;
